// Generated by CoffeeScript 2.7.0
var ExportableFilesController;

export default ExportableFilesController = class ExportableFilesController extends Skylark.App.BaseController {
  index() {
    return this.exportable_table = new Skylark.Elements.ExportableTable(DomMaster.find('.exportable-table'));
  }

};

Skylark.App.Controllers.register({ExportableFilesController});
